import apiClient from "../apiClient";

const resource = "doctorsAppointments";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    approval: (id,doctorId) => apiClient.put(`${resource}/${id}/approval?doctorId=${doctorId}`),
    review: (id, payload) => apiClient.put(`${resource}/${id}/review`,payload),
    followUp: (id, doctorId) => apiClient.put(`${resource}/${id}/followUp?doctorId=${doctorId}`),
    unfollowUp: (id, doctorId) => apiClient.put(`${resource}/${id}/unfollowUp?doctorId=${doctorId}`),
    //   -----------------------------------
    servicesApproval: (id, doctorId) => apiClient.put(`${resource}/${id}/servicesApproval?doctorId=${doctorId}`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    getForProcedures: id => apiClient.get(`${resource}/${id}/procedures`),
    getAttachment:(id) => apiClient.get(`${resource}/${id}/attachment`,{
    responseType: 'blob'
  }),
     
    UpdateProcedure: (id, payload) => apiClient.put(`${resource}/${id}/procedures`, payload,{ 'Content-Type': 'multipart/form-data' }),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),

};
